export const isString = (data: unknown) => typeof data === 'string'
